<template>
  <div class="contentPage">
    <main-table
        v-if="safetyStatementsFilterList"
        flag="safetyStatements"
        text-create="Create statement"
        page-title="Safety statements"
        :headers="headers"
        :listItems="safetyStatementsList"
        :filtersList="safetyStatementsFilterList"
        :uniqId="uniqId"
        @updateClickButton="onClickButton"
        @updateCreate="onCreate(true)"
        @updateSearch="onFilter"
        @updateRefreshFilters="onFilter"
        @updateChangeSort="onFilter"
        @updateExport="onExport"
        @updateSettings="onSettingsOpen"
        isExport
        isSettings
    ></main-table>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('safety-statement')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>

    <safety-statements-create
        v-if="isCreateStatements"
        @updateClose="onCreate(false)"
        @updateView="onView(true)"
    ></safety-statements-create>

    <safety-statements-view
        v-if="isSafetyStatementsView"
        @updateCloseViewDialog="onView(false)"
    ></safety-statements-view>

    <remove-block
        v-if="isRemove"
        :preloader="loading"
        @updateRemoveItem="onRemoveItem"
        @updateRemoveClose="onRemoveClose"
    ></remove-block>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
const SafetyStatementsCreate = () => import('@/components/Accounting/SafetyStatements/SafetyStatementsCreate/SafetyStatementsCreate');
const SafetyStatementsView = () => import('@/components/Accounting/SafetyStatements/SafetyStatementsView/SafetyStatementsView');
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// constants
import { PERMISSIONS } from "@/constants/constants";
// mixins
import settingsMixins from "@/mixins/settingsMixins";

export default {
	name: "SafetyStatements",
	mixins: [ settingsMixins ],
	components: {
		SafetyStatementsCreate,
		SafetyStatementsView,
		RemoveBlock,
	},
	computed: mapGetters([
		'customers',
		'safetyStatementsList',
		'safetyStatementsFilterList',
		'linksPermissions',
		'permissions'
	]),
	data: () => ({
		refreshFilters: false,
		isRemove: false,
		loading: false,
		isCreateStatements: false,
		isSafetyStatements: false,
		isSendSafetyStatements: false,
		isDrawerSafetyStatements: false,
		isSafetyStatementsView: false,
		dataActions: null,
		editRow: null,
		uniqId: null,
		link: null
	}),
	methods: {
		...mapActions([
			'getSafetyStatementsList',
			'createSchedule',
			'onEditSchedule',
			'setWarning',
			'onSafetyStatementsFilter',
			'onExportLink',
			'onRemoveSafetyStatements',
			'onSafetyStatementsCreate'
		]),
		async onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
				this.itemId = line.id;
				this.isSafetyStatements = true;
			}
		},
		async onClickButton({ key, item }) {
			if (key === "openLoads") {
				if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW] || this.permissions[PERMISSIONS.CREATE_EDIT_TRIP]) {
					await this.onSafetyStatementsCreate(item);
					this.isSafetyStatementsView = true;
				}
			}
			if (key === "delete") {
				this.removeId = item.id;
				this.isRemove = true;
			}
		},
		async onRemoveItem() {
			this.loading = true;
			await this.onRemoveSafetyStatements(this.removeId);
			this.isRemove = false;
			this.loading = false;
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onCreate(value) {
			if (!value) this.itemId = null;
			this.isCreateStatements = value;
		},
		onView(value) {
			this.isSafetyStatementsView = value;
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'safety-statement' });
		},
		async onFilter(info) {
			await this.onSafetyStatementsFilter(info.filterModList);
		},
	},
	async created() {
		await this.getSafetyStatementsList();
	}
};
</script>

<style scoped lang="scss"></style>
